import TopbarLinks from './TopbarLinks.vue';

export default TopbarLinks;